import clsx from 'clsx'
import { default as NextLink, LinkProps as NextLinkProps } from 'next/link'

import styles from './Link.module.scss'

type LinkVariant = 'inherit' | 'primary'
export interface LinkProps
  extends NextLinkProps,
    Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> {
  variant?: LinkVariant
}

export default function Link({
  variant = 'primary',
  className,
  ...props
}: LinkProps) {
  return (
    <NextLink
      {...props}
      className={clsx(
        styles.link,
        variant === 'inherit' ? styles.inherit : styles.primary,
        className
      )}
    />
  )
}
